exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bulma .modal-card-body[data-v-33adcede] {\n    display: inherit;\n}\n", ""]);

// exports
